"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWithImageChoicesGameplayContainer = void 0;
const react_1 = __importStar(require("react"));
const gameplay_components_1 = require("../../gameplay_components");
const material_1 = require("@mui/material");
const react_2 = require("react");
const howler_1 = require("howler");
const choice_fulfillment_1 = require("../../choice_fulfillment");
const types_1 = require("../types");
const asset_key_generator_1 = require("../../asset_key_generator");
const framer_motion_1 = require("framer-motion");
const animations_1 = require("../../animations");
const TextWithImageChoicesGameplayContainer = ({ props, }) => {
    const propFactory = new gameplay_components_1.TextWithImageChoicesGameplayComponentPropsFactory(props.card, props.gameplayStyle, props.fileUrls);
    const choiceFulfillmentController = new choice_fulfillment_1.ChoiceFulfillmentController(props.card);
    const dfQuestionTopProps = propFactory.createQuestionTopProps();
    const dfQuestionTextProps = propFactory.createQuestionTextProps();
    const dfQuestionChoiceProps = propFactory.createQuestionChoiceProps();
    // animation
    const [shouldExit, setShouldExit] = (0, react_2.useState)(false);
    // states
    const [userChoices, setUserChoices] = (0, react_2.useState)([]);
    const [questionTopProps, setQuestionTopProps] = (0, react_2.useState)(dfQuestionTopProps);
    const [questionTextProps, setQuestionTextProps] = (0, react_2.useState)(dfQuestionTextProps);
    const [questionChoiceProps, setQuestionChoiceProps] = (0, react_2.useState)(dfQuestionChoiceProps);
    const [assetsLoaded, setAssetsLoaded] = (0, react_2.useState)(false);
    // refs
    const questionAudioRef = (0, react_1.useRef)();
    const postAnswerAudioRef = (0, react_1.useRef)();
    const questionChoicePropsRef = (0, react_1.useRef)();
    questionChoicePropsRef.current = questionChoiceProps;
    // callbacks
    const handleChoicesChange = (identifier) => {
        if (choiceFulfillmentController.shouldAppendToLastChoice(userChoices)) {
            let lastChoice = userChoices[userChoices.length - 1];
            lastChoice = lastChoice + identifier;
            setUserChoices([
                ...userChoices.slice(0, userChoices.length - 1),
                lastChoice,
            ]);
        }
        else {
            const newChoices = [...userChoices];
            newChoices.push(identifier);
            setUserChoices(newChoices);
        }
    };
    function onPresentStart() {
        console.log('animation started');
    }
    function onPresentComplete() {
        console.log('animation ended');
        if (props.gameplayControl === types_1.GameplayControl.PresentQuestion) {
            playQuestionAudios();
            if (props.onPresentQuestion) {
                props.onPresentQuestion(props.card);
            }
        }
    }
    function onAnimationComplete() {
        if (!questionChoicePropsRef.current) {
            return;
        }
        const answerTexts = props.card.cardAnswer.answerTexts;
        const updatedProps = {
            ...questionChoicePropsRef.current,
            identifiersForAnimation: undefined,
            onAnimationComplete: undefined,
            highlightedChoices: answerTexts,
        };
        setQuestionChoiceProps(updatedProps);
        if (props.onPresentAnswer) {
            props.onPresentAnswer(props.card);
        }
        playPostAnswerAudios(() => {
            setTimeout(() => {
                if (props.onFinishCard) {
                    props.onFinishCard(props.card);
                    setShouldExit(true);
                }
            }, props.wrongAnswerDisplayTime * 1000);
        });
    }
    // functions
    function playQuestionAudios(onEnd = undefined) {
        if (questionAudioRef.current && questionAudioRef.current.playing()) {
            questionAudioRef.current.stop();
        }
        if (props.card.cardQuestion.questionAudios.length === 0) {
            if (onEnd) {
                onEnd();
            }
            return;
        }
        const audioNames = props.card.cardQuestion.questionAudios;
        const audioUrls = [];
        audioNames.forEach(audioName => {
            const assetKey = asset_key_generator_1.AssetKeyGenerator.key(audioName, asset_key_generator_1.AssetType.Audio);
            const url = props.fileUrls.get(assetKey);
            if (url) {
                audioUrls.push(url);
            }
        });
        if (audioUrls.length === 0) {
            if (onEnd) {
                onEnd();
            }
            return;
        }
        const questionAudioHowl = new howler_1.Howl({
            src: audioUrls,
            html5: true,
            onend: onEnd,
            onloaderror: onEnd,
            onplayerror: onEnd,
        });
        questionAudioRef.current = questionAudioHowl;
        questionAudioHowl.play();
    }
    function playPostAnswerAudios(onEnd = undefined) {
        if (postAnswerAudioRef.current && postAnswerAudioRef.current.playing()) {
            postAnswerAudioRef.current.stop();
        }
        if (props.card.cardQuestion.postAnswerAudios.length === 0) {
            if (onEnd) {
                onEnd();
            }
            return;
        }
        const audioNames = props.card.cardQuestion.postAnswerAudios;
        const audioUrls = [];
        audioNames.forEach(audioName => {
            const assetKey = asset_key_generator_1.AssetKeyGenerator.key(audioName, asset_key_generator_1.AssetType.Audio);
            const url = props.fileUrls.get(assetKey);
            if (url) {
                audioUrls.push(url);
            }
        });
        if (audioUrls.length === 0) {
            if (onEnd) {
                onEnd();
            }
            return;
        }
        const postAnswerHowl = new howler_1.Howl({
            src: audioUrls,
            html5: true,
            onend: onEnd,
            onloaderror: onEnd,
            onplayerror: onEnd,
        });
        postAnswerAudioRef.current = postAnswerHowl;
        postAnswerHowl.play();
    }
    // hooks
    (0, react_2.useEffect)(() => {
        if (choiceFulfillmentController.isFulfilled(userChoices)) {
            if (props.onAnswerQuestion) {
                props.onAnswerQuestion(userChoices, props.card);
            }
        }
    }, [userChoices]);
    (0, react_2.useEffect)(() => {
        async function loadAll() {
            const promises = questionChoiceProps.choices.map(src => {
                return new Promise(resolve => {
                    const img = new Image();
                    img.src = src;
                    img.onload = () => resolve();
                    img.onerror = () => resolve();
                });
            });
            return Promise.all(promises).then(() => {
                console.log('done loading images @ container');
            });
        }
        loadAll().then(() => setAssetsLoaded(true));
    }, [questionChoiceProps]);
    (0, react_2.useEffect)(() => {
        setQuestionTopProps(dfQuestionTopProps);
        setQuestionTextProps(dfQuestionTextProps);
        setQuestionChoiceProps(dfQuestionChoiceProps);
    }, []);
    (0, react_2.useEffect)(() => {
        if (!questionChoiceProps) {
            console.log('question choice props is missing in gameplay control setter!!');
            return;
        }
        switch (props.gameplayControl) {
            case types_1.GameplayControl.PresentAnswerWithCorrectResponse: {
                const answerTexts = props.card.cardAnswer.answerTexts;
                const choiceProps = {
                    ...questionChoiceProps,
                    highlightedChoices: answerTexts,
                };
                setQuestionChoiceProps(choiceProps);
                if (props.onPresentAnswer) {
                    props.onPresentAnswer(props.card);
                }
                if (props.card.gameplayInfo.alwaysPlayPostAnswerAudios) {
                    playPostAnswerAudios(() => {
                        setTimeout(() => {
                            if (props.onFinishCard) {
                                props.onFinishCard(props.card);
                                setShouldExit(true);
                            }
                        }, props.rightAnswerDisplayTime * 1000);
                    });
                }
                else {
                    setTimeout(() => {
                        if (props.onFinishCard) {
                            props.onFinishCard(props.card);
                            setShouldExit(true);
                        }
                    }, props.rightAnswerDisplayTime * 1000);
                }
                break;
            }
            case types_1.GameplayControl.PresentAnswerWithIncorrectResponse: {
                const choiceProps = {
                    ...questionChoiceProps,
                    identifiersForAnimation: props.selectedChoices,
                    onAnimationComplete: onAnimationComplete,
                };
                setQuestionChoiceProps(choiceProps);
                break;
            }
            default:
                return;
        }
    }, [props]);
    return (react_1.default.createElement(framer_motion_1.AnimatePresence, null, !shouldExit ? (assetsLoaded ? (react_1.default.createElement(framer_motion_1.motion.div, { key: 'TextWithImageContainer', initial: props.enableAnimation &&
            props.gameplayControl === types_1.GameplayControl.PresentQuestion
            ? { opacity: 0, x: '16%' }
            : false, animate: animations_1.presentAnimation, exit: animations_1.dismissAnimation, onAnimationStart: onPresentStart, onAnimationComplete: onPresentComplete },
        react_1.default.createElement(material_1.Box, { id: `text-image-choices-${props.gameplayStyle}`, sx: {
                height: props.height,
                width: props.width,
            } },
            react_1.default.createElement(material_1.Box, { id: "gameplay-questiontop-container", sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    height: { xs: '7%', md: '10%' },
                } }, questionTopProps && (react_1.default.createElement(gameplay_components_1.AttributeText, { text: questionTopProps.text, gameplayStyle: questionTopProps.gameplayStyle, className: questionTopProps.className }))),
            react_1.default.createElement(material_1.Box, { id: "gameplay-questiontext-container", sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: { xs: '7%', md: '10%' },
                } }, questionTextProps && (react_1.default.createElement(gameplay_components_1.AttributeText, { text: questionTextProps.text, gameplayStyle: questionTextProps.gameplayStyle, className: questionTextProps.className, onInteract: () => {
                    var _a, _b;
                    if ((_a = questionAudioRef.current) === null || _a === void 0 ? void 0 : _a.playing()) {
                        return;
                    }
                    else {
                        (_b = questionAudioRef.current) === null || _b === void 0 ? void 0 : _b.play();
                    }
                } }))),
            react_1.default.createElement(material_1.Box, { width: "100%", height: { sm: '0%', md: '5%' } }),
            react_1.default.createElement(material_1.Box, { id: "gameplay-questionchoice-container", sx: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginTop: { xs: '2rem', md: 0 },
                }, height: { xs: 'auto', sm: '63%', md: '68%' } }, questionChoiceProps && (react_1.default.createElement(gameplay_components_1.ImageChoiceButtons, { imageNames: questionChoiceProps.imageNames, choices: questionChoiceProps.choices, highlightedChoices: questionChoiceProps.highlightedChoices, disabled: questionChoiceProps.disabled, onInteract: identifier => {
                    var _a;
                    if ((_a = questionAudioRef.current) === null || _a === void 0 ? void 0 : _a.playing()) {
                        questionAudioRef.current.stop();
                    }
                    handleChoicesChange(identifier);
                }, height: props.height.toString(), width: props.width.toString(), className: questionChoiceProps.className, gameplayStyle: questionChoiceProps.gameplayStyle, identifiersForAnimation: questionChoiceProps.identifiersForAnimation, onAnimationComplete: questionChoiceProps.onAnimationComplete }))),
            react_1.default.createElement(material_1.Box, { width: '100%', height: '8%' })))) : (react_1.default.createElement(material_1.Box, { id: `text-image-choices-${props.gameplayStyle}`, sx: {
            height: props.height,
            width: props.width,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        react_1.default.createElement(react_1.default.Fragment, null)))) : (react_1.default.createElement(react_1.default.Fragment, null))));
};
exports.TextWithImageChoicesGameplayContainer = TextWithImageChoicesGameplayContainer;
